import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

export function provideClientMenu(): EnvironmentProviders {
  return makeEnvironmentProviders([]);
}
